/* eslint-disable */
import {
  AfterViewInit,
  Component,
  forwardRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {AG_GRID_LOCALE_EN, AG_GRID_LOCALE_IT, IoniconsOutline} from '@pt/pt-models';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ColDef, ColumnApi, GridApi, GridOptions} from "ag-grid-community";
import {ApiClientConfig} from "@pt/api-client";
import {CustomRendererComponent} from "../../../ag-grid";
import {ag_grid_frameworkComponents} from "../../../pt-shared.constant";
import {TranslateService} from "@ngx-translate/core";
import {Resource} from "it/primatoo/openapi/api/org/schemas/databreachprocess/incidentteam/Resource";
import { InputUserChooserData } from './input-user-chooser-data';

@Component({
  selector: 'pt-input-user-chooser',
  templateUrl: './input-user-chooser.component.html',
  styles: [`
    .user-chooser-container {
      max-width: 550px;
    }
    .ng-value-label-custom {
      max-width: 150px;
    }
  `],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputUserChooserComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputUserChooserComponent),
      multi: true
    }
  ]
})
export class InputUserChooserComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit, ControlValueAccessor {
  @ViewChild('actionCol', {static: true}) actionColTemplateRef: TemplateRef<unknown>;
  @ViewChild('nameCol', {static: true}) nameColTemplateRef: TemplateRef<unknown>;
  @ViewChild('roleCol', {static: true}) roleColTemplateRef: TemplateRef<unknown>;

  @Input() label?: string;
  @Input() controlName: string;
  @Input() options: InputUserChooserData<Resource>;
  @Input() disabled: boolean;
  public dialogMembers: Array<Resource> = [];
  public dialogSelectedMembers: Array<number> = [];
  public formGroup: FormGroup;
  public gridOptions: GridOptions = null;
  public columnsDef: ColDef[];
  public inputId: string;
  public selectedMembers: Array<Resource> = [];
  public IconRemove = IoniconsOutline.close;
  public gridApi: GridApi;
  public columnApi: ColumnApi;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val: any) => void;
  private onTouched: () => void;
  private readonly env: any;

  constructor(@Inject(ApiClientConfig) private config: ApiClientConfig,
              private translate: TranslateService
  ) {
    this.env = this.config.env;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.gridOptions = {
      ...this.env.defaultGridOptions,
      localeText: this.translate.currentLang == 'it' ? AG_GRID_LOCALE_IT : AG_GRID_LOCALE_EN,
      suppressPropertyNamesCheck: true,
      components: ag_grid_frameworkComponents,
    } as GridOptions;

    this.inputId = 'ptInputUserChooserComponent_' + this.controlName;

    this.formGroup = new FormGroup({
      value: new FormControl([])
    });

    this.alignSelect();

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      if (this.onChanged) {
        this.onChanged(t.value);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }

  writeValue(team: Array<Resource>): void {
    const currentValue = team ? team : [];
    this.formGroup.controls.value.setValue(currentValue, {emitEvent: false});
    this.alignSelect();
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formGroup.controls.value.disable();
    } else {
      this.formGroup.controls.value.enable();
    }
  }

  validate(_value: FormControl) {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  removeMember(member: Resource) {
    this.selectedMembers = this.selectedMembers.filter(m => m.id != member.id);
    this.formGroup.controls.value.setValue(this.selectedMembers);
    this.alignSelect();
  }

  addMember() {
    if (this.dialogSelectedMembers.length > 0) {
      const actualSelectedMembers: Resource[] = this.formGroup.controls.value.value || [];
      const newSelectedMember = this.options.items.filter((o) => this.dialogSelectedMembers.includes(o.id)).map(m => {
        return {...m, role: ''}
      });
      actualSelectedMembers.push(...newSelectedMember);
      this.formGroup.controls.value.setValue(actualSelectedMembers);
    }
    this.alignSelect();
  }

  customSearchFn(term: string, item: Resource) {
    term = term.toLowerCase();
    return item.fullName.toLowerCase().indexOf(term) > -1;
  }

  ngAfterViewInit(): void {
    this.columnsDef = [
      {
        field: "fullName",
        headerName: "Nome",
        hide: false,
        editable: false,
        suppressMenu: true,
        suppressNavigable: true,
        flex: 1,
        resizable: true,
        floatingFilter: false,
        sortable: true,
        lockVisible: true,
        cellClass: 'no-border',
        cellRenderer: CustomRendererComponent,
        cellRendererParams: {
          ngTemplate: this.nameColTemplateRef
        }
      },
      {
        field: "role",
        headerName: "Ruolo",
        hide: false,
        editable: false,
        suppressMenu: true,
        suppressNavigable: true,
        flex: 1,
        resizable: true,
        floatingFilter: false,
        sortable: true,
        lockVisible: true,
        cellClass: 'no-border',
        cellRenderer: CustomRendererComponent,
        cellRendererParams: {
          ngTemplate: this.roleColTemplateRef
        }
      }, {
        headerName: '',
        field: 'actions',
        flex: 1,
        suppressMenu: true,
        width: 70,
        minWidth: 70,
        maxWidth: 70,
        suppressNavigable: true,
        lockVisible: true,
        editable: false,
        cellClass: 'no-border',
        cellRenderer: CustomRendererComponent,
        cellRendererParams: {
          ngTemplate: this.actionColTemplateRef
        }
      }
    ] as Array<ColDef>;
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.alignSelect()
  }

  changeRole(row: Resource, role: string) {
    this.selectedMembers.forEach((v: Resource) => {
      if (v.id === row.id) {
        v.role = role
      }
    })
    this.formGroup.controls.value.setValue(this.selectedMembers);
  }

  private alignSelect() {
    this.dialogSelectedMembers = [];
    const alreadySelectedValue: Resource[] = this.formGroup ? this.formGroup.controls.value.value || [] : [];
    this.dialogMembers = this.options ? this.options.items.filter((i: Resource) => !alreadySelectedValue.find(a => a.id === i.id)) : [];
    this.selectedMembers = JSON.parse(JSON.stringify(alreadySelectedValue));
  }
}


